<template lang="pug">
  .entries-wrapper(:class="'context-' + context")
    include Category.pug
</template>

<script>
import _ from 'underscore'
import Api from '@/components/services/Api'
import RestrictedAreaBlock from '@/components/restricted_area_block/RestrictedAreaBlock'
import { mapState } from 'vuex';

export default {
  name: 'Category',
  components: { RestrictedAreaBlock },
  props: ['slug', 'childSlug'],
  computed: mapState([
    "context",
  ]),
  data() {
    return {
      entries: [],
      entry: null,
    }
  },
  created() {
    const _this = this

    this.$wagtail.getEntries(this.slug, false).then(response => {
      let data = response.data
      _this.entries = data.results
    })
    _this.loadEntry()
  },
  methods: {
    loadEntry() {
      const _this = this
      _this.$wagtail
        .getEntry(this.childSlug, false)
        .then(response => {
          let data = response.data.results
          let fullEntry = _.first(data)
          if (fullEntry) {
            _this.entry = fullEntry
          }
        })
        .catch(err => {})
    },
    isRestricted(entry) {
      let token = this.$store.state.token
      if (token) return false

      let tags = Api.translateTags(entry.tags)
      return _.contains(tags, 'only-professional')
    },
    changeEntry(entry) {
      this.entry = entry
    },
  },
  watch: {
    $route(to, from) {
      this.loadCategory(to.params.slug)
    },
  },
}
</script>

<style lang="scss">
@import './../variables';
.entry-wrapper {
  display: block;
  padding-left: $gutter * 2;
  padding-right: $gutter * 2;
  padding-bottom: $gutter;
  margin-bottom: $gutter * 4;
  margin-top: $gutter * 4;
  min-height: 150px;

  h1 {
    font-weight: 700;
    font-size: 2.2em;
    margin: $gutter * 4 0 50px 0;
    margin-top: 0;
  }

  hr {
    margin: 0;
    border: 2px solid $color-primary;
    margin-bottom: $gutter * 3;
    display: block;
    clear: both;
    width: 55px;
  }

  @include breakpoint($breakpoint-tablet) {
    hr {
      display: none;
    }
  }
}

.entries-list-wrapper {
  margin-top: $gutter * 4;

  h3 {
    background-color: #e3e3e2;
    text-align: center;
    font-size: 1.4em;
    font-weight: 700;
    color: $color-primary;
    padding: $gutter 0;
  }
}
.entries-list {
  padding-bottom: $gutter;
  background-color: #e3e3e2;

  li {
    @include clearfix();
    width: 100%;
    text-align: center;
    font-weight: 400;
    padding: $gutter 0;
    position: relative;
    height: $gutter * 4;
    cursor: pointer;

    a {
      color: #000;
    }

    .inner-item {
      position: absolute;
      left: 12px;
      bottom: 0;
      right: 12px;
      top: 0;

      display: flex;
      border-bottom: 1px solid #fff;
      align-items: center;
      justify-content: center;

      span {
        display: inline-block;
        text-align: left;
        width: 100%;
      }
    }

    &.active {
      background-color: #fff;
      color: $color-primary;
      font-weight: 700;
      .inner-item {
        border-bottom: 1px solid rgba(0, 0, 0, 0);
      }
    }
  }
}

.entry-html-wrapper {
  img {
    width: 100%;
  }

  p {
    a {
      color: $color-black;
      text-decoration: underline;
    }
  }
}

.category-box {
  @include breakpoint($breakpoint-tablet) {
    h3 {
      display: none;
    }
  }
  a {
    color: $color-black;
  }
}

@import './../variables';
@import './../variables_colreps';
@import './../variables_mexreps';
.category-wrapper {
  margin: $gutter * 6 auto;
  max-width: 1140px;

  @import 'Faqs';

  p,
  li {
    font-size: 1.25rem;
    line-height: 1.45;
    letter-spacing: -0.2px;
    text-align: justify;
  }

  p {
    margin-bottom: 2rem;

    b {
      font-weight: bold;
    }

    em,
    i {
      font-style: italic;
    }
  }

  h2 {
    font-weight: bold;
    font-size: 1.8125rem;
    padding-bottom: 1rem;
  }

  h3 {
    font-weight: bold;
    font-size: 1.625rem;
    padding-bottom: 1rem;
  }

  h4 {
    font-weight: bold;
    font-size: 1.375rem;
    padding-bottom: 1rem;
  }

  .entry-html-wrapper {
    ul,
    ol {
      padding-left: 1.25rem;

      li a {
        color: #000;
        text-decoration: underline;
      }
    }

    ul,
    ol {
      list-style: initial;
    }
    ol {
      list-style: decimal;
    }
  }
}

.context-colreps {
  .category-wrapper {
    h2:after {
      border: 2px solid $color-accent-colreps;
    }

    .category-box ul li.active,
    .category-box ul li:hover {
      background-color: $color-accent-colreps;
    }
  }
}

.context-mexreps {
  .category-wrapper {
    h2:after {
      border: 2px solid $color-accent-mexreps;
    }

    .category-box ul li.active,
    .category-box ul li:hover {
      background-color: $color-accent-mexreps;
      
      a {
        color: $color-white-mexreps;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Category.vue